import PropTypes from 'prop-types'
import { connectSortBy } from 'react-instantsearch-dom'

import { SelectUI } from '@redriverpress/system'

// Extension of Algolia's SortBy component
// https://www.algolia.com/doc/api-reference/widgets/sort-by/react/
function SortBy({ items, currentRefinement, defaultRefinement, refine }) {
  return (
    <SelectUI
      label='Sort By'
      icon='sort-alt'
      value={currentRefinement || defaultRefinement}
      onChange={e => refine(e.currentTarget.value)}
    >
      {items.map(item => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </SelectUI>
  )
}

SortBy.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentRefinement: PropTypes.string.isRequired,
  defaultRefinement: PropTypes.string.isRequired,
  refine: PropTypes.func.isRequired,
}

export default connectSortBy(SortBy)
